import script from "./ChecklistStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChecklistStep.vue?vue&type=script&setup=true&lang=ts"

import "./ChecklistStep.vue?vue&type=style&index=0&id=96586364&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96586364"]])

export default __exports__